/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React examples
import DefaultPricingCard from "examples/Cards/PricingCards/DefaultPricingCard";
import BusinessPricingCard from "examples/Cards/PricingCards/BusinessPricingCard";

// Material Dashboard 2 PRO React context
import { useMaterialUIController } from "context";

function PricingCards() {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  return (
    <MDBox position="relative" zIndex={10} mt={8} px={{ xs: 1, sm: 0 }}>
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} lg={4}>
          <DefaultPricingCard
            color={darkMode ? "dark" : "white"}
            badge={{ color: darkMode ? "warning" : "light", label: "free" }}
            price={{ value: "Free" }}
            specifications={[
              { label: "1 data point only(Limited)", highlight: true },
              { label: "1 upload data periods(Limited)", highlight: true },
              { label: "Environment data of all terms", highlight: false },
              { label: "Data storage and Processing", highlight: false },
              { label: "Performance forecast", highlight: false },
              { label: "Environment analysis", highlight: false },
              { label: "Financial Viabiligy", highlight: false },
              { label: "Email support within 5 business days(General only)", highlight: false },
            ]}
            action={{
              type: "internal",
              route: "/",
              color: darkMode ? "warning" : "dark",
              label: "Activate",
            }}
            shadow={darkMode}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <BusinessPricingCard
            color="dark"
            badge={{ color: "info", label: "Business" }}
            specifications={[
              { label: "Per 1 data point(Unlimited}", highlight: true },
              { label: "Unlimited upload data periods", highlight: true },
              { label: "Environment data of all terms", highlight: false },
              { label: "Data storage and Processing", highlight: false },
              { label: "Perfomance forecast", highlight: false },
              { label: "Environment analysis", highlight: false },
              { label: "Financial Viabiligy", highlight: false },
              {
                label: "Email support within 2 business days(Technical/General)",
                highlight: false,
              },
            ]}
            action={{
              type: "internal",
              route: "/",
              color: "info",
              label: "Activate",
            }}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <DefaultPricingCard
            color={darkMode ? "dark" : "white"}
            badge={{ color: darkMode ? "warning" : "light", label: "Customize" }}
            price={{ value: "Contact" }}
            specifications={[
              { label: "API integration", highlight: false },
              { label: "OEM development", highlight: false },
              { label: "Original AI model", highlight: false },
            ]}
            action={{
              type: "internal",
              route: "/",
              color: darkMode ? "warning" : "dark",
              label: "Contact to us",
            }}
            shadow={darkMode}
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}

// Typechecking props for the PricingCards
PricingCards.propTypes = {
  prices: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default PricingCards;
